import { render, staticRenderFns } from "./MessageCenterChat.vue?vue&type=template&id=68182eb6&scoped=true&"
import script from "./MessageCenterChat.vue?vue&type=script&lang=js&"
export * from "./MessageCenterChat.vue?vue&type=script&lang=js&"
import style0 from "./MessageCenterChat.vue?vue&type=style&index=0&id=68182eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68182eb6",
  null
  
)

export default component.exports